export default "__VITE_ASSET__BqHeYYbT__"